<template>
  <div class="update-info">
    <div v-if="hasDiff">
      <data-table
        table-title=""
        :title-list="titleList"
        :data-list="dataList">
      </data-table>
      <section class="btn-bottom" @click="handleSubmit">
        <div class="btn-fix">
          <a class="btn">确定更新</a>
        </div>
      </section>
    </div>
    <p v-else class="update-info__no-diff">{{ message }}</p>
  </div>
</template>

<script>
import DataTable from '../analysis/components/DataTable'

export default {
  components: {
    DataTable
  },
  data() {
    return {
      params: {
        'task_id': '',
        'store_id': null,
        'ins_car_id': null
      },
      titleList: [
        {
          key: 'name',
          name: ''
        },
        {
          key: 'before',
          name: '系统数据'
        },
        {
          key: 'after',
          name: '保司数据'
        }
      ],
      dataList: [],
      hasDiff: false,
      message: '查询中'
    }
  },
  mounted() {
    this.getParams()
    this.fetchDiff()
  },
  methods: {
    /**
     * 得到url参数
     */
    getParams() {
      /* eslint-disable camelcase */
      const { task_id, store_id, ins_car_id } = this.$route.query
      this.params.task_id = task_id
      this.params.store_id = parseInt(store_id)
      this.params.ins_car_id = parseInt(ins_car_id)
    },
    /**
     * 请求差异信息
     */
    async fetchDiff() {
      const res = await this.$rest.insurance.updateInfo.getDiff(this.params)
      if (res.code !== 8) {
        this.message = res.message.message || res.message.error_message || ''
        return
      }
      if (!res.data.length) {
        this.message = '暂无差异信息'
        return
      }
      this.hasDiff = true
      this.dataList = res.data
    },
    /**
     * 确定更新
     */
    async handleSubmit() {
      const res = await this.$rest.insurance.updateInfo.update(this.params)
      if (res.code !== 0) {
        // 更新失败
        this.$router.replace({
          path: '/insurance/updateInfoResult/fail',
          query: {
            failMsg: res.message
          }
        })
        return
      }
      // 更新成功
      this.$router.replace('/insurance/updateInfoResult/success')
    }
  }
}
</script>

<style lang="less">
.update-info {
  background-color: #fff;
  &__no-diff {
    font-size: 15px;
    color: #000;
    text-align: center;
    padding: 50px;
  }
}
</style>
